import React from 'react';
export const BlogHeader = () => {
  return <div className="bg-white border-b border-gray-200 py-3" data-id="element-72">
      <div className="max-w-4xl mx-auto px-4 flex items-center" data-id="element-73">
        <div className="flex items-center space-x-3" data-id="element-74">
          <div className="w-10 h-10 rounded-full overflow-hidden bg-white flex items-center justify-center" data-id="element-75">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4ruTDHQfohwkv5RjVD53JW/yogas.png?logo=true&t=1" alt="Yoga" className="w-full h-full object-cover" loading="eager" fetchpriority="high" onError={e => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = 'https://uploadthingy.s3.us-west-1.amazonaws.com/4ruTDHQfohwkv5RjVD53JW/yogas.png';
          }} data-id="element-76" />
          </div>
          <div data-id="element-77">
            <h1 className="font-serif text-xl font-bold text-green-800" data-id="element-78">
              Sofias Hälsoblogg
            </h1>
            <p className="text-xs text-gray-500" data-id="element-79">
              Ärliga tankar om hälsa, välmående & livsstil
            </p>
          </div>
        </div>
      </div>
    </div>;
};